import React from 'react';
import { useSelector } from 'react-redux';
import { terminalSummarySelector } from 'slices/terminal-summary/terminalSummarySlice';
import TerminalSummaryState from 'slices/terminal-summary/TerminalSummaryState';

const TerminalDetails = ({ terminalNumber }: { terminalNumber: string }) => {
  const terminalSummaryState: TerminalSummaryState = useSelector(terminalSummarySelector);
  const terminalExists = terminalNumber && terminalSummaryState.terminallist?.find((terminal) => terminal.terminalNumber.toString() === terminalNumber)
  return (
    terminalExists ? <div className="driver-details__terminal-details ">
      {`${terminalExists?.airportCode} -  
      ${terminalExists?.terminalName} `}
      <span>{terminalNumber}</span>
    </div> : <></>
  );
};

export default TerminalDetails;
